import type {
  ContactOrderAppointmentRow,
  ContactOrderDigitalChannel,
} from "../../../_logic/contact-orders-contract"
import {
  dateFromBatchValues,
  dateMatchesBatchRange,
  textMatchesBatchSearch,
  type BatchDateRangeFilter,
} from "../../../_logic/filter-values"
import { customerInformationModeIsCompleted } from "../_shared/_logic/customer-information-state"

export type ContactOrderPlanningFilterState = {
  search: string
  status: string
  channel: string
  recipientStatus: string
  employee: string
  dateRange: BatchDateRangeFilter
}

export const createContactOrderPlanningFilters = (
  overrides: Partial<ContactOrderPlanningFilterState> = {},
): ContactOrderPlanningFilterState => ({
  search: "",
  status: "pending",
  channel: "",
  recipientStatus: "",
  employee: "",
  dateRange: { start: "", end: "" },
  ...overrides,
})

export const contactOrderPlanningRowStatus = (row: ContactOrderAppointmentRow) =>
  row.event.contact_order_id || customerInformationModeIsCompleted(row.customerInformationMode)
    ? "created"
    : "pending"

const rowDate = (row: ContactOrderAppointmentRow) => dateFromBatchValues(row.event.start_at)

export const filterContactOrderPlanningRows = (
  rows: ContactOrderAppointmentRow[],
  filters: ContactOrderPlanningFilterState,
  selectedCustomerIdsForRow: (row: ContactOrderAppointmentRow) => string[],
  selectedChannelsForRow: (row: ContactOrderAppointmentRow) => ContactOrderDigitalChannel[],
) =>
  rows.filter((row) => {
    const selectedCustomerIds = selectedCustomerIdsForRow(row)
    const selectedChannels = selectedChannelsForRow(row)

    return (
      (!filters.status ||
        filters.status === "all" ||
        contactOrderPlanningRowStatus(row) === filters.status) &&
      (!filters.channel ||
        selectedChannels.includes(filters.channel as ContactOrderDigitalChannel)) &&
      (!filters.recipientStatus ||
        (filters.recipientStatus === "selected"
          ? selectedCustomerIds.length > 0
          : selectedCustomerIds.length === 0)) &&
      (!filters.employee || row.employee === filters.employee) &&
      dateMatchesBatchRange(rowDate(row), filters.dateRange) &&
      textMatchesBatchSearch(filters.search, [
        row.orderTag.label,
        row.orderTag.numberLabel,
        row.orderTag.subLabel,
        row.termin,
        row.timeLabel,
        row.employee,
        row.propertyTag.label,
        row.propertyTag.subLabel,
        row.addressLines.join(" "),
        row.recipients
          .map((recipient) => `${recipient.nameLabel} ${recipient.roleLabel ?? ""}`)
          .join(" "),
      ])
    )
  })
